import { useForm } from '@inertiajs/react';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface DeleteCredentialDialogProps {
  eventSlug: string;
  credentialId: string;
  credentialSlug: string;
}

export function DeleteCredentialDialog({
  eventSlug,
  credentialId,
  credentialSlug,
}: DeleteCredentialDialogProps) {
  const [open, setOpen] = useState(false);
  const form = useForm({});
  const { processing } = form;
  const errors = form.errors as unknown as Record<string, string | undefined>;

  const handleDelete = () => {
    form.delete(`/admin/${eventSlug}/credentials/${credentialId}`, {
      preserveScroll: true,
      onSuccess: () => setOpen(false),
    });
  };

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setOpen(true)}
        className="text-red-600 hover:bg-red-50 hover:text-red-700"
      >
        <Trash2 className="h-4 w-4" />
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete printed credential</AlertDialogTitle>
            <AlertDialogDescription>
              Delete <strong>{credentialSlug}</strong> from the ledger? The
              physical card keeps existing, but its QR stops resolving to
              whoever it was assigned to.
            </AlertDialogDescription>
          </AlertDialogHeader>
          {errors.delete && (
            <div className="rounded-md border border-red-200 bg-red-50 p-3">
              <p className="text-red-600 text-sm">{errors.delete}</p>
            </div>
          )}
          <AlertDialogFooter>
            <AlertDialogCancel disabled={processing}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={handleDelete}
              disabled={processing}
              className="bg-red-600 hover:bg-red-700"
            >
              {processing ? 'Deleting...' : 'Delete'}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
